import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import components
import AdminDashboard from '../components/admin/AdminDashboard';
import AdminManagement from '../components/admin/AdminManagement';
import SchoolManagement from '../components/admin/SchoolManagement';
import BlogManagement from '../components/admin/BlogManagement';
import BlogForm from '../components/admin/BlogForm';
import EventManagement from '../components/admin/EventManagement';
import EventRegistrations from '../components/admin/EventRegistrations';
import EventForm from '../components/admin/EventForm';
import AdminProfile from '../components/admin/AdminProfile';
import AdminSettings from '../components/admin/AdminSettings';
import SubscriptionSettings from '../components/admin/SubscriptionSettings';
import DiscountCodeManagement from '../components/admin/DiscountCodeManagement';
import BulkMessaging from '../components/admin/BulkMessaging';
import NotFound from '../pages/public/NotFound';

/**
 * Nested routes configuration for the admin panel
 */
const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/dashboard" element={<AdminDashboard />} />
      <Route path="/admins" element={<AdminManagement />} />
      <Route path="/schools" element={<SchoolManagement />} />
      
      {/* Blog Management Routes */}
      <Route path="/blogs" element={<BlogManagement />} />
      <Route path="/blogs/new" element={<BlogForm />} />
      <Route path="/blogs/edit/:id" element={<BlogForm />} />
      
      {/* Event Management Routes */}
      <Route path="/events" element={<EventManagement />} />
      <Route path="/events/new" element={<EventForm />} />
      <Route path="/events/edit/:id" element={<EventForm />} />
      <Route path="/event-registrations" element={<EventRegistrations />} />
      
      <Route path="/profile" element={<AdminProfile />} />
      <Route path="/settings" element={<AdminSettings />} />
      <Route path="/subscriptions" element={<SubscriptionSettings />} />
      <Route path="/discount-codes" element={<DiscountCodeManagement />} />
      <Route path="/bulk-messaging" element={<BulkMessaging />} />
      {/* Add any other admin-specific routes here */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AdminRoutes; 